import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import { EmployeePermission } from 'src/api/permissions';
import { Loader } from 'src/components/Loader/Loader';
import { getUserState } from 'src/store/user/selectors';

import { ErrorIcon } from './ErrorIcon';
import classes from './ProtectedRoute.module.scss';

export interface ProtectedRouteProps {
  permission: EmployeePermission;
  children?: ReactNode;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
  permission,
  children,
}) => {
  const { loading, data } = useSelector(getUserState);

  if (loading) {
    return (
      <div className={classes.fallback}>
        <Loader />
      </div>
    );
  }

  if (!data?.permissions.has(permission)) {
    return (
      <div className={classes.fallback}>
        <ErrorIcon />
        <Typography variant='subtitle1'>
          У вас нет прав работать в сервисе. Обратитесь в HelpDesk.
        </Typography>
      </div>
    );
  }

  return children;
};
